import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { GenericDialogData } from '../models/generic.dialog.interface';
import { FieldTechnician } from '../../shared/models/field.technician.interface';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-field-technician',
  templateUrl: './field.technician.component.html',
  styleUrls: ['./field.technician.component.scss']
})
export class FieldTechnicianComponent implements OnInit {

  constructor(private adminService: AdminService, public dialogRef: MatDialogRef<FieldTechnicianComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialogData) { }
  fieldTechnician: FieldTechnician;
  errors: string;
  isRequesting: boolean;
  ngOnInit() {
    let fieldTechnicianId: string = this.data.id;
    let dealerId = this.adminService.getDealerId();

    if (fieldTechnicianId == null) {
      this.fieldTechnician = {} as FieldTechnician;
      this.fieldTechnician.fieldTechnician_IsActive = true;
    }
    else {
      this.adminService.getFieldTechnician(fieldTechnicianId)
        .subscribe({
          next: (data) => {
            this.fieldTechnician = data;
          }
        });
    }
  }

  saveFieldTechnician(form: NgForm) {
    console.log('in resources onSubmit: ', this.fieldTechnician);
    this.errors = '';
    if (form.valid) {
      this.isRequesting = true;

      let dealerId = this.adminService.getDealerId();
      this.fieldTechnician.dealer_ID = dealerId;

      this.adminService.saveFieldTechnician(this.fieldTechnician)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
            if (result) {
              this.dialogRef.close();
            }
          },
          error: (error: string) => {
            this.errors = error;
          }
        });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
